import { faBuilding, faCalendarDays, faTable } from '@fortawesome/free-solid-svg-icons'
import createField from '../../../utils/factory/createField'

export const accountingFilterFields = [
  {
    section: 'Filtros do relatório contábil',
    fields: [
      createField({
        id: 'filter.start_date',
        label: 'Transações a partir de',
        placeholder: 'Data inicial',
        type: 'date',
        icon: faCalendarDays,
      }),
      createField({
        id: 'filter.end_date',
        label: 'Transações até',
        placeholder: 'Data final',
        type: 'date',
        icon: faCalendarDays,
      }),
      createField({
        id: 'filter.organization_ids',
        label: 'Organizações',
        placeholder: 'Todas as organizações',
        type: 'select',
        isMulti: true,
        isClearable: true,
        icon: faBuilding,
      }),
      createField({
        id: 'filter.mode',
        label: 'Formato do relatório',
        placeholder: 'Selecione o formato',
        type: 'select',
        icon: faTable,
      }),
    ],
  },
]
